/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A place for VDK Web CTV UI components and utilities (@accedo/vdkweb-tv-ui) 7.1.0
* 
*******************************************************************************/
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["children", "nav", "theme", "className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * Function similar to FocusButton, but all events are fired from the DIV instead
 * by the button. Use this instead of FocusButton for complex children that
 * does not fit in a single line.
 */
import React from 'react';
import T from 'prop-types';
import { withFocus } from '@accedo/vdkweb-navigation';
import buttonTheme from './focusDivButton.scss';

/**
 * FocusDivButton is an HTML5 `<div>` wrapper with any defined child as prop. This set up
 * allows the FocusDivButton not only handle traditional mouse click, but also
 * provides spatial navigation, an essential functionality for application on CTV.
 *
 * @returns {React.ReactElement} The FocusDivButton Element
 */
export var FocusDivButtonComponent = function FocusDivButtonComponent(_ref) {
  var children = _ref.children,
    _ref$nav = _ref.nav,
    nav = _ref$nav === void 0 ? {} : _ref$nav,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? {} : _ref$theme,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    props = _objectWithoutProperties(_ref, _excluded);
  var isFocused = nav.isFocused,
    onMouseOver = nav.onMouseOver,
    onMouseOut = nav.onMouseOut;
  var newTheme = _objectSpread(_objectSpread({}, buttonTheme), theme);
  var _newTheme$button = newTheme.button,
    button = _newTheme$button === void 0 ? '' : _newTheme$button,
    _newTheme$buttonFocus = newTheme.buttonFocused,
    buttonFocused = _newTheme$buttonFocus === void 0 ? '' : _newTheme$buttonFocus;
  var mergedClassName = "".concat(button, " ").concat(isFocused ? buttonFocused : '', " ").concat(className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: mergedClassName,
    onMouseOut: onMouseOut,
    onMouseOver: onMouseOver
  }, props), children);
};
FocusDivButtonComponent.propTypes = {
  /** Reacts special prop, children. */
  children: T.node,
  /** Class name that will be applied to the `<div>` element.  */
  className: T.string,
  /** Navigation property, see `@accedo/vdkweb-navigation`. */
  nav: T.object,
  /** React onClick event handler function, which will be added to the element. */
  onClick: T.func,
  /** Allow overriding the className of the button in standard and focus state. */
  theme: T.object
};
export default withFocus(FocusDivButtonComponent);